import type WorkflowRunDocumentView from '@UI/Store/WorkflowRuns/Views/WorkflowRunDocumentView';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * The documents of one stage of the generation, `stage` 0-indexed (displayed `stage + 1`).
 */
class WorkflowRunDocumentStageView {
	readonly stage: number;
	readonly documents: readonly WorkflowRunDocumentView[];

	constructor(stage: number, documents: readonly WorkflowRunDocumentView[]) {
		this.stage = stage;
		this.documents = documents;

		Object.freeze(this);
	}
}

export default WorkflowRunDocumentStageView;
